import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_REVENUE_LOCALIZED_MEMBERSHIP_ASK_HEADLINE = createFcmDetails(
	'revenue_localized_membership_ask_headline',
	{
		owner: 'Revenue Squad',
		context: 'Membership Asks, PPMU',
		import: false,
		description:
			"This FC controls the display of localized membership ask headline using signature service data for user's country or state (for US only).",
		template: {
			enabled: true,
			state_localization_enabled: true,
		},
	},
);
